import moment from 'moment';
import { AUTH_COOKIE } from 'modules/login/AuthenticationService';
class TranslateService {
    static $inject = ['$translate', '$translateCookieStorage', 'NG_TRANSLATE_LANG_KEY', '$cookies'];
    constructor($translate, $translateCookieStorage, NG_TRANSLATE_LANG_KEY, $cookies) {
        'ngInject';
        this.$translate = $translate;
        this.$translateCookieStorage = $translateCookieStorage;
        this.NG_TRANSLATE_LANG_KEY = NG_TRANSLATE_LANG_KEY;
        this.$cookies = $cookies;
        this.LANG_KEY = NG_TRANSLATE_LANG_KEY;
    }
    $onInit() { }
    setCurrentLanguage(language) {
        this.$translate.use(language);
        moment.locale(language);
    }
    getCurrentLanguage() {
        const userCookie = this.$cookies.getObject(AUTH_COOKIE);
        const account = (userCookie && userCookie.account) ? userCookie.account : {};
        const culture = account.culture || '';
        switch (culture) {
            case 'pt-BR':
                return 'pt';
            case 'en-US':
                return 'en';
            case 'es':
                return 'es';
            default:
                return this.$translateCookieStorage.get(this.LANG_KEY) || 'en';
        }
    }
    getCurrentCulture() {
        const userCookie = this.$cookies.getObject(AUTH_COOKIE);
        const account = (userCookie && userCookie.account) ? userCookie.account : {};
        return account.culture || '';
    }
    instantTranslate(key) {
        if (!key) {
            return '';
        }
        const translatedKey = this.$translate.instant(key);
        return translatedKey !== key ? translatedKey : key;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
TranslateService.$inject = ['$translate', '$translateCookieStorage', 'NG_TRANSLATE_LANG_KEY', '$cookies'];
export default TranslateService;
